import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'invoice-data',
  templateUrl: './invoice-data.component.html',
  styleUrls: ['./invoice-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class InvoiceDataComponent implements OnInit {
  @Input() columnData  = new BehaviorSubject(null);
  @Output() onAction = new EventEmitter();
  
  showInvoice:boolean= false;
  invoiceDetails:any;
  constructor() { }

  ngOnInit(): void {
  }

  OpenInvoiceDetails(invoiceNumber: string)
  {
    this.onAction.emit({action:'openinvoice',columnData:invoiceNumber});
  }
}
